{
  "fr": {
    "todo_group": {
      "actions": {
        "create": "Tâche",
        "update": "Modifier la tâche"
      },
      "attributes": {
        "category": "Catégorie",
        "created_at": "Créé le",
        "description": "Description",
        "title": "Titre",
        "todos_count": "Tâches",
        "units": "Unités"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Téléversement"
      },
      "labels": {
        "no_groups": "Aucune tâche pour ce projet pour le moment.",
        "required": "Ce champ est obligatoire"
      },
      "toasts": {
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "update": "Tâche mise à jour"
      }
    }
  }
}
